import React from 'react'
import { Form, InputNumber, Spin } from 'antd'
import { graphql } from 'react-apollo'
import _get from 'lodash/get'
import _keyBy from 'lodash/keyBy'
import ticketItemQuery from '~/App/graphql/queries/ticketItem.gql'
import raceQuery from '~/App/graphql/queries/race.gql'
import RunImageUploader from '../RunImageUploader'
import { inject, observer } from 'mobx-react'
import localeGet from '~/App/utils/localeGet'
const formItemLayout = {
  labelCol: { sm: { span: 10 }, xs: { span: 24 } },
  wrapperCol: { sm: { span: 14 }, xs: { span: 24 } }
}
@inject('i18n')
@graphql(ticketItemQuery, {
  options: props => ({
    variables: {
      _id: _get(props, 'ticketId')
    }
  }),
  skip: props => !_get(props, 'ticketId')
})
@graphql(raceQuery, {
  options: props => ({
    variables: {
      _id: _get(props, 'raceId')
    }
  }),
  name: 'raceQuery',
  skip: props => !_get(props, 'raceId')
})
@Form.create()
@observer
class RunForm extends React.Component {
  render () {
    const { data, form, i18n: { locale }, raceQuery } = this.props
    const { getFieldDecorator } = form
    
    if (data.loading) {
      return <div className="modLoadding">
        <Spin tip="Loading..." size="large" />
      </div>
    }
    const { ticketItem } = data
    if (!ticketItem) {
      return <div>TicketItem not found...</div>
    }
    if (raceQuery && raceQuery.loading) {
      return <div>Loading...</div>
    }
    const race = _get(raceQuery, 'race') || _get(ticketItem, 'ticketType.race')
    const vrSettings = _get(race, 'settings.virtualRun') || _get(ticketItem, 'event.settings.virtualRun')
    const distanceMode = _get(race, 'settings.virtualRun.distanceMode') || _get(ticketItem, 'event.settings.virtualRun.distanceMode')
    const fields = _get(vrSettings, 'fields', [])
    const enabledFields = _keyBy(fields.filter(f => f.enabled), '_id')
    getFieldDecorator('record.ticketItemId', {
      initialValue: ticketItem._id
    })
    getFieldDecorator('record.number', {
      initialValue: ticketItem.number
    })
    getFieldDecorator('record.eventId', {
      initialValue: ticketItem.eventId
    })
    getFieldDecorator('record.participantId', {
      initialValue: ticketItem.participantId
    })
    getFieldDecorator('record.raceId', {
      initialValue: race._id
    })
    const distanceDecorator = getFieldDecorator('record.distance', {
      // initialValue: race.distance,
      rules: [{ required: enabledFields['distance'] && enabledFields['distance'].required }]
    })
    return <Form>
      <h3>
        {localeGet(race, 'name', locale)} 
        {distanceMode === 'recent' && `${{ en: ' (recent)', th: ' (ส่งครั้งเดียว)' }[locale]}`} {distanceMode !== 'recent' && `${{ en: ' (cumulative)', th: ' (สะสมระยะ)' }[locale]}`}
      </h3>
      {!!enabledFields['distance'] && <Form.Item label={{ en: 'Distance', zh: 'Distance', th: 'ระยะทาง' }[locale]} {...formItemLayout}>
        {distanceDecorator(<InputNumber precision={3} />)} km
      </Form.Item>}
      {!!enabledFields['runnerImage'] && <Form.Item label={{ en: 'Runner Image', zh: 'Runner Image', th: 'ภาพนักวิ่ง' }[locale]} {...formItemLayout}>
        {getFieldDecorator('record.runnerImage', {
          rules: [{ required: enabledFields['runnerImage'].required }]
        })(<RunImageUploader />)}
      </Form.Item>}
      {!!enabledFields['activityImage'] && <Form.Item label={{ en: 'Activity Record', zh: 'Activity Record', th: 'ภาพผลการวิ่ง' }[locale]} {...formItemLayout}>
        {getFieldDecorator('record.activityImage', {
          rules: [{ required: enabledFields['activityImage'].required }]
        })(<RunImageUploader />)}
      </Form.Item>}
    </Form>
  }
}

export default RunForm



// WEBPACK FOOTER //
// ./src/App/components/RunForm/RunForm.js